import { DOCUMENT } from '@angular/common';
import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import {
  SuiModal,
  ComponentModalConfig,
  ModalSize,
} from '@richardlt/ng2-semantic-ui';
import { environment } from 'src/environments/environment';

interface IViewWatchersModalContext {
  title: string;
  data: any;
}

@Component({
  selector: 'app-view-watchers-modal',
  templateUrl: './view-watchers-modal.component.html',
  styleUrls: ['./view-watchers-modal.component.scss'],
})
export class ViewWatchersModalComponent implements OnInit, OnDestroy {
  data: any;
  watchers: any;
  baseUrl: any = environment.API_SERVER;

  constructor(
    @Inject(DOCUMENT) private document,
    public modal: SuiModal<IViewWatchersModalContext, void, void>
  ) {
    this.watchers = modal.context.data;
    console.log(this.data, 'extra');
  }

  ngOnInit() {
    this.document.body.classList.remove('panel');
  }

  ngOnDestroy(): void {
    this.document.body.classList.add('panel');
  }

  loadImage(imagePath: any) {
    return `${this.baseUrl}/public/image/?media=${imagePath.replace(
      /\\/g,
      '/'
    )}`;
  }
}

export class ViewWatchersModal extends ComponentModalConfig<
  IViewWatchersModalContext,
  void,
  void
> {
  constructor(title: string, data: any, size: ModalSize = ModalSize.Small) {
    super(ViewWatchersModalComponent, {
      title,
      data,
    });

    this.isClosable = false;
    this.isCentered = true;
    this.transitionDuration = 200;
    this.size = size;
    this.isFullScreen = false;
    this.isInverted = false;
  }
}
